import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import last from "lodash/last";
import {MdIconButton, ZzIconButtonRoute} from "core/components/buttons/icons";
import LinearProgress from 'material-ui/LinearProgress';
import ArrowBack from "material-ui/svg-icons/navigation/arrow-back";
import LongArrowLeft = require("react-icons/lib/fa/long-arrow-left");
import LongArrowRight = require("react-icons/lib/fa/long-arrow-right");
import LevelUp = require("react-icons/lib/fa/level-up");
import FaSearch = require("react-icons/lib/fa/search");
import History from "material-ui/svg-icons/action/history";
import mdEntityService from "core/metamodel/mdEntityService";
import eventService from "core/event/eventService";
import {EventHistoryDrawer} from "core/event/component/historyBlocks";
import securityService from 'core/security/securityService';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import {observer} from "mobx-react";
import {ID, SecurableComponentProps} from "core/metamodel/metaConstant";
import uiService from "core/common/service/uiService";
import gridService from "core/grid/gridService";
import {EventHistory} from "core/event/eventDomain";
import {ObservableMap} from "mobx/lib/mobx";
import {default as Grid, GridLocation, PageMapIndex} from "core/grid/domain/grid";
import {blueGrey50} from 'material-ui/styles/colors';


//const __iconStyle = {width: 40, height: 40, padding: 8};
const __iconIconStyle = {width: 18, height: 18};
const __iconIconRIFAStyle = {width: 14, height: 14};


const __styleOverride = {
  padding: 0,
  margin: 0
};

const __progressBarStyleOverride = {
  height: 2,
  width: "100%",
  backgroundColor: blueGrey50
};




interface ToolmenuProps extends React.ClassAttributes<Toolmenu> {
  children?: React.ReactNode;
  chainGridLocation?: string;
  backAction?: React.MouseEventHandler<any>;
  backDisabled?: boolean;
  style?: any;
  historize?: boolean;
  entityName?: string;
  entityId?: ID;
  activeTab?: string;
}

interface ToolmenuState {
  openHistoryDrawer?: boolean;
  loadingHistoryDrawer?: boolean;
  searchTerm?: string;
  searchTermTooltip?: string[];
  chainIconPreviousProps?: any;
  chainIconNextProps?: any;
}

@observer
export default class Toolmenu extends React.Component<ToolmenuProps, ToolmenuState> {

  static contextTypes = {
    muiTheme: PropTypes.object,
    router: PropTypes.func.isRequired
  };

  state: ToolmenuState = {
    openHistoryDrawer: false,
    loadingHistoryDrawer: false
  };

  componentDidMount() {
    console.log("Toolmenu componentDidMount , params = %O", this.context.router.getCurrentParams());
    this.computeChain(this.props);
  }

  componentWillReceiveProps(nextProps) {
    console.log("Toolmenu componentWillReceiveProps , params = %O", this.context.router.getCurrentParams());
    this.computeChain(nextProps);
  }

  computeChain(props) {
    let {
      chainGridLocation,
      activeTab, // hack protoze soucasna integrace router & path nefunguje
    } = props;

    let chainIconNextProps = null, chainIconPreviousProps = null;
    let previousPromise: Promise<PageMapIndex>, nextPromise: Promise<PageMapIndex>;

    if (chainGridLocation) {
      let params = this.context.router.getCurrentParams();

      if (params.id) {
        let grid: Grid = gridService.getGrid(chainGridLocation);

        if (grid && grid.data) {
          let routeName = (last(this.context.router.getCurrentRoutes()) as ReactRouter.Route).name;

          // hack protoze soucasna integrace router & path nefunguje
          let query = Object.assign({}, this.context.router.getCurrentQuery());
          if (activeTab) query.tab = activeTab;

          let gridData = grid.data;

          let currentIndex = gridData.findRowIndex(params.id);

          if (currentIndex) {

            if (!gridData.isFirstIndex(currentIndex)) {
              let previousIndex = gridData.previousIndex(currentIndex);

              previousPromise = (previousIndex) ? Promise.resolve(previousIndex) : grid.search(null, false, currentIndex.plane - 1)
                .then(() => {
                  return gridData.previousIndex(currentIndex);
                });

              previousPromise.then(pi => {
                let row = gridData.getRow(pi);
                if (row && row.rowId != null) {
                  chainIconPreviousProps = {
                    routeName, query,
                    params: Object.assign({}, params, {id: row.rowId}),
                  };
                }
              });

            }
            if (!gridData.isLastIndex(currentIndex)) {
              let nextIndex = gridData.nextIndex(currentIndex);

              nextPromise = (nextIndex) ? Promise.resolve(nextIndex) : grid.search(null, false, currentIndex.plane + 1)
                .then(() => {
                  return gridData.nextIndex(currentIndex);
                });

              nextPromise.then(pi => {
                let row = gridData.getRow(pi);
                if (row && row.rowId != null) {
                  chainIconNextProps = {
                    routeName, query,
                    params: Object.assign({}, params, {id: row.rowId}),
                  };
                }
              });

            }
          }

          if (!nextPromise) nextPromise = Promise.resolve(null);
          if (!previousPromise) previousPromise = Promise.resolve(null);
          Promise.all([previousPromise, nextPromise])
            .then(() => {
              this.setState({chainIconPreviousProps, chainIconNextProps});
          });
        }
      }
    }
  }




  handleHistory = (evt) => {
    let {entityName, entityId} = this.props;
    console.log('handleHistory %s, id %s', entityName, entityId);

    if (this.state.openHistoryDrawer) {
      this.setState({
        openHistoryDrawer: false
      });
    } else {

      this.setState({openHistoryDrawer: true, loadingHistoryDrawer: true});

      let metadataPromise = mdEntityService.fetchEntityMetadata(['EventHistory', 'HistoryObject', 'HistoryObjectField']);
      let historyPromise = eventService.readHistory(entityName, entityId);

      return Promise.all([metadataPromise, historyPromise])
        .then( ([entityMap, eventHistories]: [any, EventHistory[]]) => {
          eventService.eventHistories = eventHistories;
          this.setState({loadingHistoryDrawer: false});
        });
    }
  };


  handleHistoryRequestChange = (open) => {
    if (!open) {
      eventService.eventHistories = null;
    }
    this.setState({openHistoryDrawer: open});
  };

  onSearchTermChange = evt => {
    this.setState({searchTerm: evt.target.value || ''});
  };

  onSearchTermSubmit = evt => {
    evt.preventDefault();
    console.log('onSearchTermSubmit: %s', this.state.searchTerm);
  };

  onEnterSearch = evt => {
    console.log('onEnterSearch');
    return gridService.fetchGrids(this.props.chainGridLocation)
      .then((gridLocations: ObservableMap<GridLocation>) => {
        this.setState({searchTermTooltip: gridLocations.get(this.props.chainGridLocation).getActiveGridConfig().searchLabel});
      });
  };

  render() {

    let {
      children,
      chainGridLocation,
      backAction,
      backDisabled,
      style,
      historize,
      entityName,
      entityId,
      activeTab, // hack protoze soucasna integrace router & path nefunguje
      ...other
      } = this.props;


    let {
      chainIconPreviousProps,
      chainIconNextProps,
      searchTermTooltip,
      openHistoryDrawer,
      loadingHistoryDrawer
    } = this.state;

    console.log('%c render toolmenu %s  %s , query = %O', "background-color: #DDDDFF", chainGridLocation, activeTab, this.context.router.getCurrentQuery());


    style = (!style) ? {} : style;
    Object.assign(style, {justifyContent:'space-between'});


    let lastTA;
    if (uiService.transitionArray && uiService.transitionArray.length) {
      lastTA = Object.assign({}, last(uiService.transitionArray));
      lastTA.query = Object.assign({}, lastTA.query, {direction: 'up'});
    }

    // prava
    const arrayChildren = (React.Children.toArray(children) as React.ReactElement<SecurableComponentProps>[]).filter( child => {
      return securityService.hasRouterRight(this.context.router, child.props.module, child.props.securableType, child.props.securable, child.props.permission, child.props.detailId);
    });

    const augmentedChildren = arrayChildren.map((child, index) =>
      React.cloneElement<SecurableComponentProps, SecurableComponentProps>(
          child,
          {
            key: index,
            style: Object.assign({},__styleOverride, child.props.style)
          }
        )
      );

    if (historize) {
      augmentedChildren.unshift(
        <MdIconButton key={-1} onToolbar onClick={this.handleHistory} disabled={!entityId} >
          <History/>
        </MdIconButton>);
    }


    const searchTermTooltipFrag = (searchTermTooltip) ? searchTermTooltip.map((text, i) => (
      <span key={i}>{text}<br/></span>)) : null;

    return (
      <div style={{position: 'sticky', top:40, zIndex: 100, left: 0, right: 0}}>

        { (openHistoryDrawer) ? <EventHistoryDrawer eventHistories={eventService.eventHistories} entities={mdEntityService.entityMap}
                                                               open={openHistoryDrawer} loading={loadingHistoryDrawer}
                                                               onRequestChange={this.handleHistoryRequestChange} /> : null }

        <Toolbar>

          <ToolbarGroup firstChild>
            {augmentedChildren}
          </ToolbarGroup>

            <ToolbarGroup lastChild>

              { (chainGridLocation && 1 !== 1) ? (
                <IconButton onMouseEnter={this.onEnterSearch} onClick={backAction} style={{paddingRight:0, paddingLeft:0, width:25, height: 40}} iconStyle={__iconIconRIFAStyle}
                            tooltipPosition="bottom-center" tooltip={searchTermTooltipFrag}
                >
                  <FaSearch/>
                </IconButton>

              ) : null }

              {
                (backAction) ? (
                  <IconButton onClick={backAction} style={{paddingRight:0, paddingLeft:0, width:25, height: 40}} iconStyle={__iconIconStyle}  disabled={backDisabled}>
                    <ArrowBack/>
                  </IconButton>
                ) : null
              }

              <ZzIconButtonRoute {...lastTA} style={{paddingLeft:0, width:25}} iconStyle={__iconIconRIFAStyle} disabled={!lastTA} >
                <LevelUp/>
              </ZzIconButtonRoute>


              { (chainGridLocation) ? (
                <ZzIconButtonRoute style={{paddingRight:0, paddingLeft:0, width:25}} iconStyle={__iconIconRIFAStyle}
                                   disabled={!chainIconPreviousProps} {...chainIconPreviousProps}>
                  <LongArrowLeft/>
                </ZzIconButtonRoute>
              ) : null }
              { (chainGridLocation) ? (
                <ZzIconButtonRoute style={{paddingLeft:0, width:25}} iconStyle={__iconIconRIFAStyle}
                                   disabled={!chainIconNextProps} {...chainIconNextProps}>
                  <LongArrowRight/>
                </ZzIconButtonRoute>
                ) : null }
            </ToolbarGroup>
        </Toolbar>
        { (uiService.getToolbarActionFlag()) ? <LinearProgress mode="indeterminate" style={__progressBarStyleOverride} /> : <div style={__progressBarStyleOverride}/>}

      </div>

    )


  }

}




// WEBPACK FOOTER //
// ./src/core/components/toolmenu/toolmenu.tsx